import envPublic from '@/config/env.public';

const metaTypeParams = {
  whisky: 'whisky',
  rum: 'rum',
  gin: 'gin',
  other: 'other',
  whiskyName: [
    'Ardbeg Committee',
    'Ardbeg 13 year old anthology',
    'Macallan amber meadow',
    'Bruichladdich Black Art',
    'Laphroaig Ian Hunter',
    'Springbank Local Barley',
    'Glenfiddich Grand',
    'Yamazaki Limited Edition',
    'Hibiki Blossom Harmony',
    'Blantons Gold Edition',
    'St.Killian Signature',
    'Kavalan Solist',
    'Bimber Underground',
    'Midleton Very Rare',
  ],
  algoliaIndex: envPublic.NEXT_PUBLIC_ALGOLIA_INDEX?.toLowerCase(),
  algoliaIndexMostWatchedDesc: envPublic.NEXT_PUBLIC_ALGOLIA_REPLICA_BY_WATCHED?.toLowerCase(),
  scotland: 'scotland',
  usa: 'usa',
  japan: 'japan',
  ireland: 'ireland',
  germany: 'germany',
  taiwan: 'taiwan',
};

export default {
  metaTypeParams,
};
